resetApolloContext